<template>
  <div class="mobile-user-review">
    <div class="mobile-user-review__user-info">
      <img
        :src="require(`@/pages/book/components/images/app-reviews/${locale}/${review.avatar}`)"
        class="mobile-user-review__avatar"
        :alt="userAvatarAltText">

      <div class="mobile-user-review__username">
        {{ review.username }}

        <rating-stars
          class="mt-2 m:ml-2 m:mt-0"
          star-classes="w-3 h-3"
          :mark="review.rating" />
      </div>
    </div>

    <div
      class="mobile-user-review__review">
      <span
        v-html="reviewContent" />

      <a
        v-if="!showFullReview"
        @click.prevent="showFullReview = true"
        href="#">
        {{ $t("seeMore") }}
      </a>
    </div>
  </div>
</template>

<script>
import RatingStars from "@/features/smartbanner/components/rating_stars";

export default {
  name: "MobileUserReview",
  components: {
    RatingStars
  },
  props: {
    review: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showFullReview: false
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    reviewContent() {
      if (this.showFullReview) {
        return this.review.review.replace("[break]", " ");
      } else {
        return this.review.review.split("[break]")[0] + "...";
      }
    },
    userAvatarAltText() {
      return this.$t("userAvatarAltText", { username: this.review.username });
    }
  },
  created() {
    this.showFullReview = !(this.review.review.indexOf("[break]") > -1);
  },
  i18n: {
    messages: {
      en: {
        seeMore: "See more",
        userAvatarAltText: "User avatar - {username}"
      },
      de: {
        seeMore: "Mehr sehen",
        userAvatarAltText: "User avatar - {username}"
      }
    }
  }
};
</script>

<style lang="scss">
.mobile-user-review {

  &__user-info {
    display: flex;
    align-items: center;
    margin-bottom: $spacing-16;
  }

  &__username {
    @include font-style(subheadline, $color: $midnight);
  }

  &__avatar {
    @include font-style(h2, $color: $white, $weight: normal);

    display: block;
    width: spacing(56px);
    height: spacing(56px);
    margin-right: $spacing-16;

    text-transform: capitalize;

    background-color: $blue;

    border-radius: 50%;
  }

  &__review {
    @include font-style(p1, $color: $dark-grey);
  }

  @include media(min-width, m) {
    display: none;
  }
}
</style>
